import { ReactNode } from "react";

import { ApplicationHeader } from "@/components/navigation/ApplicationHeader"
import { ApplicationSidebar } from "@/components/navigation/ApplicationSidebar"
import { SidebarInset, SidebarProvider } from "@ui/sidebar"
import { Toaster } from "@ui/sonner"
import { useUserSession } from "@session/UserSession"

interface ApplicationLayoutProps {
    children?: ReactNode | ReactNode[]
}
export function ApplicationLayout({ children }: Readonly<ApplicationLayoutProps>) {
    const { user } = useUserSession()

    return user ? (
        <div className="[var(--header-height):calc(theme(spacing.14))]">
            <Toaster position="top-right" toastOptions={{ style: { zIndex: 9999 } }} />
            <SidebarProvider defaultOpen={false} className="flex flex-col">
                <ApplicationHeader />
                <div className="flex max-h-[calc(100vh-var(--header-height)-1px)]">
                    <ApplicationSidebar />
                    <SidebarInset className='min-h-[calc(100vh-var(--header-height)-1px)] max-h-[calc(100vh-var(--header-height)-1px)]'>
                        <div className="h-full w-full overflow-auto">
                            {children}
                        </div>
                    </SidebarInset>
                </div>
            </SidebarProvider>
        </div>
    ) : (
        <main className="flex-1 overflow-hidden">{children}</main>
    )
}
